import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { LoaderMini } from '~/components/Loaders';
import { useSelector } from 'react-redux';
import { SubHeader } from '~/components/SubHeader';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';
import Filipeta from '~/components/Filipeta';
import { symbolPriceFormatter } from '~/helpers/price';

function DetalhesLink() {
	const { user } = useSelector((state) => state.auth);
	const { detalhe } = useSelector((state) => state.clientMaquinaVirtual);

	return (
		<Container fluid>
			<SubHeader
				breadcrumb={[
					{
						page: 'Lucree por click',
						link: '/client/maquina-virtual',
					},
					{
						page: 'Detalhes do Link',
						link: '/client/detalhes-link',
					},
				]}
			/>
			{!detalhe.payer_details ? (
				<div className="d-flex justify-content-center">
					<LoaderMini />
				</div>
			) : (
				<>
					<Row
						className="my-5 border-bottom pb-2"
						style={{ alignItems: 'center' }}>
						<Col md="9" className="d-flex aling-items-center">
							<Text size="large">Detalhes do Link</Text>
						</Col>
						<Col md="2" className="d-flex justify-content-end">
							<Link
								to="/client/maquina-virtual"
								style={{ color: `${color.blue}` }}>
								Voltar
							</Link>
						</Col>
						<Col md="1" className="d-flex justify-content-end">
							{detalhe.paid ? (
								<Text size="big" weight="bold" color="green">
									Pago
								</Text>
							) : (
								<Text size="big" weight="bold" color="orange">
									Pendente
								</Text>
							)}
						</Col>
					</Row>

					<Row>
						<Col lg="4">
							<Card
								style={{ boxShadow: 'unset' }}
								className="w-100">
								<CardBody>
									<div className="d-flex justify-content-between my-4">
										<Text weight="bold" size="medium">
											Dados do Link
										</Text>
									</div>
									<div className="d-flex align-items-center mb-3">
										<Text weight="bold" size="default">
											Título:
										</Text>
										<Text size="default" className="pl-3">
											{detalhe.link_title}
										</Text>
									</div>
									<div className="d-flex align-items-center mb-3">
										<Text weight="bold" size="default">
											Valor total:
										</Text>
										<Text size="default" className="pl-3">
											{symbolPriceFormatter(
												detalhe.amount,
												'detalheLink'
											)}
										</Text>
									</div>
									<div className="d-flex align-items-center mb-3">
										<Text weight="bold" size="default">
											Número de Parcelas:
										</Text>
										<Text size="default" className="pl-3">
											{`${detalhe.installments}x`}
										</Text>
									</div>
									<div className="d-flex align-items-center mb-4">
										<Text weight="bold" size="default">
											Valor por parcela:
										</Text>
										<Text size="default" className="pl-3">
											{symbolPriceFormatter(
												detalhe.amount_per_installment,
												'detalheLink'
											)}
										</Text>
									</div>
								</CardBody>
							</Card>
						</Col>
						{Object.keys(detalhe.payer_details).length > 0 && (
							<Col lg="4">
								<Card
									style={{ boxShadow: 'unset' }}
									className="w-100">
									<CardBody>
										<div className="d-flex justify-content-between my-4">
											<Text weight="bold" size="medium">
												Dados do Pagador
											</Text>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Text weight="bold" size="default">
												Pagador:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{detalhe.payer_details.name}
											</Text>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Text weight="bold" size="default">
												CPF / CNPJ:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{
													detalhe.payer_details
														.document_number
												}
											</Text>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Text weight="bold" size="default">
												E-mail:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{detalhe.payer_details.email}
											</Text>
										</div>
										<div className="d-flex align-items-center mb-4">
											<Text weight="bold" size="default">
												Telefone de contato:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{
													detalhe.payer_details
														.phone_number
												}
											</Text>
										</div>
									</CardBody>
								</Card>
							</Col>
						)}
						{Object.keys(detalhe.payer_details).length > 0 && (
							<Col lg="4">
								<Card
									style={{ boxShadow: 'unset' }}
									className="w-100">
									<CardBody>
										<div className="d-flex justify-content-between my-4">
											<Text weight="bold" size="medium">
												Endereço de Cobrança
											</Text>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Text weight="bold" size="default">
												CEP:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{
													detalhe.payer_details
														.billing_postal_code
												}
											</Text>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Text weight="bold" size="default">
												Rua / Avenida:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{
													detalhe.payer_details
														.billing_street
												}
											</Text>
										</div>
										<div className="d-flex align-items-center mb-3">
											<Text weight="bold" size="default">
												Número:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{
													detalhe.payer_details
														.billing_number
												}
											</Text>
										</div>
										<div className="d-flex align-items-center mb-4">
											<Text weight="bold" size="default">
												Cidade:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{
													detalhe.payer_details
														.billing_city
												}
											</Text>

											<Text
												className="pl-3"
												weight="bold"
												size="default">
												UF:
											</Text>
											<Text
												size="default"
												className="pl-3">
												{
													detalhe.payer_details
														.billing_state
												}
											</Text>
										</div>
									</CardBody>
								</Card>
							</Col>
						)}
					</Row>
					{detalhe.paid && (
						<Row>
							<Col className="d-flex aling-items-center my-2">
								<Card
									style={{
										boxShadow: 'unset',
									}}
									className="w-100">
									<CardBody
										style={{
											backgroundColor: color.primary,
										}}>
										<Text color="white" weight="bold">
											Comprovante de Pagamento
										</Text>
									</CardBody>
									<CardBody style={{ padding: '0 15px' }}>
										<Row
											className="d-flex justify-content-center p-2"
											style={{
												backgroundColor: color.gray,
											}}>
											<Col
												lg="6"
												className="d-flex aling-items-center my-2">
												<Filipeta
													dados={{
														modalidade: 'Crédito',
														numeroCartao:
															'**** **** **** ****',
														valor: symbolPriceFormatter(
															detalhe.amount,
															'detalheLink'
														),
														nomeUser:
															user.dados.nome,
														documentoUser:
															user.dados
																.documento,
														nome: detalhe
															.payer_details.name,
														idVenda:
															detalhe
																.payer_details
																.status_payment
																.payment_id,
														autorizacao:
															detalhe
																.payer_details
																.status_payment
																.authorization_number,
														data: detalhe.created_at,
														dataPag:
															detalhe.updated_at,
														recorrencia:
															detalhe.recurrent_payment,
														frequenciaRecorrencia:
															detalhe.recurrence_type,
													}}
												/>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
						</Row>
					)}
				</>
			)}
		</Container>
	);
}

export default DetalhesLink;
